import { createIdentifier } from '@blocksuite/global/di';
import type { ExtensionType } from '@blocksuite/store';

import type { HiveUserInfo } from './types';

export interface WriterInfoService {
  getWriterInfo(): HiveUserInfo | null;
}

export const WriterInfoProvider = createIdentifier<WriterInfoService>(
  'hive-writer-info-service'
);

export function WriterInfoServiceExtension(
  service: WriterInfoService
): ExtensionType {
  return {
    setup(di) {
      di.addImpl(WriterInfoProvider, () => service);
    },
  };
}
